import { motion } from "framer-motion"
import { renderBlockContent } from "../kit/blocks";
import { useNavigate } from "react-router";

export default function Footer({ settings }) {
  const { mainColor, footer } = settings
  const router = useNavigate();

  return (
    <div className="container mx-auto px-5 py-8">
      <div className={"grid grid-cols-12 gap-4"}>
        <div className="md:col-span-8 col-span-12">
          <div> {footer && renderBlockContent(footer)}</div>

          <br />
        </div>
        <div className="md:col-span-4 col-span-12 ">
          {[
            { "name": "Okenní parapety", "link": "/okenni-parapety" },
            { "name": "Fasády", "link": "/fasady" },
            { "name": "Balkonové systémy", "link": "/balkonove-systemy-modula-400" },
            { "name": "Terasy", "link": "/terasy" },
            { "name": "Balkony", "link": "/balkony" },
            { "name": "Stolové desky", "link": "/stolove-desky" },
            { "name": "Stoly a nábytek", "link": "/stoly-a-nabytek" }
          ].map((n, i) => <motion.div
            key={"abc" + n.link + i}
            className='font-semibold '
            style={{ color: mainColor, paddingLeft: "0.4rem", borderLeft: mainColor + " 3px solid", marginTop: "9px" }}
            whileHover={{ color: "#000", borderColor: "#000", cursor: "pointer" }}
            onClick={() => router(n.link)}
          > {n.name}
          </motion.div>
          )}


        </div>
      </div>
      <br />
      <hr />
      <div className="text-center pt-4">
        Copyright © 2025 IDAKO s.r.o.
      </div>

    </div>
  );
}
